<template>
    <v-row class="mx-0">
        <v-col cols="12" md="12" class="d-flex pt-4 pt-md-0 px-4 px-md-0 pt-md-5 pb-2 pb-md-0">
            <v-autocomplete
                v-model="model"
                :class="{'smart-search': useDefaultClass}"
                :items="items"
                :filter="filterObjects"
                :loading="isLoading"
                :placeholder="placeholder || $t('siteSearch')"
                :prepend-icon="!useInnerPrependIcon ? prependIcon : ''"
                :prepend-inner-icon="useInnerPrependIcon ? prependIcon : ''"
                :rounded="rounded"
                :search-input.sync="search"
                :color="color"
                :background-color="backgroundColor"
                :filled="filled"
                :dark="dark"
                :light="light"
                :solo="solo"
                :full-width="fullWidth"

                append-icon=""
                clearable
                clear-icon="clear"
                hide-no-data
                item-text="description"
                item-value="link"
                return-object
            ></v-autocomplete>
        </v-col>
        <!--<v-col cols="12" md="4" class="d-flex justify-center align-center pl-0 pl-md-4 pb-2 pb-md-0 pt-0 pt-md-3">
            <slot name="region"></slot>
        </v-col>-->
    </v-row>
</template>

<script>
    import SmartSearchService from '../../services/api/SmartSearchService';
    import LangService from '../../services/LangService';
    import './smart-search.scss'

    export default {
        name: "SmartSearch",
        props: {
            classes: {
                required: false,
                type: String,
                default: '',
            },
            placeholder: {
                required: false,
                type: String,
            },
            color: {
                required: false,
                type: String,
                default: 'white',
            },
            backgroundColor: {
                required: false,
                type: String,
                default: '',
            },
            rounded: {
                required: false,
                type: Boolean,
                default: false,
            },
            filled: {
                required: false,
                type: Boolean,
                default: false,
            },
            dark: {
                required: false,
                type: Boolean,
                default: false,
            },
            light: {
                required: false,
                type: Boolean,
                default: false,
            },
            solo: {
                required: false,
                type: Boolean,
                default: false,
            },
            fullWidth: {
                required: false,
                type: Boolean,
                default: false,
            },
            useInnerPrependIcon: {
                required: false,
                type: Boolean,
                default: false,
            },
            useDefaultClass: {
                required: false,
                type: Boolean,
                default: false,
            },
        },
        data(){
            return {
                descriptionLimit: 60,
                entries: [],
                entriesProbable: [],
                isLoading: false,
                model: null,
                search: null,
                pixelSenderTimeOut: 0,
                prependIcon: null
            }
        },
        computed: {
            fields () {
                if (!this.model) return [];

                return Object.keys(this.model).map(key => {
                    return {
                        key,
                        value: this.model[key] || 'n/a',
                    }
                })
            },
            items () {

                let headers = _.uniq(this.entries.map(item=>item.group));
                let arr = [];

                headers.forEach(header => {

                    arr.push({ header: header })
                    arr = arr.concat(
                        this.entries.filter(item=>{
                            return item.group == header;
                        })
                    )
                    arr.push( { divider: true } )
                })

                if(this.entriesProbable.length > 0){
                    arr.push( { header: this.$t('mayBeSearch') })
                    arr = arr.concat(this.entriesProbable);
                } else {
                    arr.pop();
                }
                return arr;
            },
        },
        methods: {
            filterObjects(item, queryText, itemText) {
                if(item.description != undefined) {
                    const transTextEn = LangService.getEnToRu(queryText);
                    const transTextRu = LangService.getRuToEn(queryText);

                    return (
                        item.description.toLowerCase().indexOf(queryText.toLowerCase()) > -1 ||
                        item.description.toLowerCase().indexOf(transTextEn.toLowerCase()) > -1 ||
                        item.description.toLowerCase().indexOf(transTextRu.toLowerCase()) > -1
                    );
                }
                return item;
            },
            mapEntriesArray(array, addToProbableGroup = false){
                if(array.length > 0) {
                    return array.map(entry => {
                        const description = entry.description.length > this.descriptionLimit
                            ? entry.description.slice(0, this.descriptionLimit) + '...'
                            : entry.description;

                        const obj = {
                            description: description,
                            link: entry.link,
                        }
                        if(addToProbableGroup){
                            obj.group = this.$t('mayBeSearch');
                        } else {
                            switch(entry.type) {
                                case 'products' : obj.group = this.$t('orderProducts'); break;
                                case 'companies' : obj.group = this.$t('companies'); break;
                                case 'categories' : obj.group = this.$t('categories'); break;
                                default: obj.group = entry.type;
                            }
                        }
                        return obj;
                    })
                }
                return [];
            },
        },
        mounted() {
            setTimeout(() => {
                this.prependIcon = 'search';
            }, 2000);
        },
        watch: {
            search(val) {
                clearTimeout(this.pixelSenderTimeOut);
                if (window.fbq) {
                    this.pixelSenderTimeOut = setTimeout(() => {
                            window.fbq('track', 'Search', {
                                search_string: val
                            });
                    }, 1000);
                }

                // if (this.items.length > 0) return;
                if(val && val.length < 3) return;

                // if (this.isLoading) return;

                this.isLoading = true;

                SmartSearchService.setLocale(this.$store.state.language.appLanguage);
                SmartSearchService.getSearchResult(val)
                    .then(res => res.data)
                    .then(res => {
                        const {count, entries, entriesProbable} = res;
                        this.count = count;
                        this.entries = this.mapEntriesArray(entries);
                        this.entriesProbable = this.mapEntriesArray(entriesProbable, true);
                    })
                    .catch(err => {
                        console.log(err)
                    })
                    .then(() => (this.isLoading = false))
            },
            model() {
                if(!this.model) return false;

                if (this.$router.currentRoute.path !== this.model.link && this.model) {
                    this.$emit('update-search', this.model);
                    this.$router.push(this.model.link).then(() => this.model = null);
                }
            }
        }
    }
</script>

<style scoped>

</style>
